import { TOGGLE_DARK_MODE, SET_DARK_MODE } from "../actions/themeActions"

const initialState = {
  isDarkMode: true,
}

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_DARK_MODE:
      console.log("Reducer: Toggling dark mode", { before: state.isDarkMode, after: !state.isDarkMode })
      return {
        ...state,
        isDarkMode: !state.isDarkMode,
      }
    case SET_DARK_MODE:
      console.log("Reducer: Setting dark mode to", action.payload)
      return {
        ...state,
        isDarkMode: action.payload,
      }
    default:
      return state
  }
}

export default themeReducer
